import { TBENames, TBEVersion } from "../../services/axios/Axios.type";

export const API_LAVORIS_URL: TBENames = "API_LAVORIS_URL";
export const B: TBENames = "B";

export const V1: TBEVersion = "v1";
